import { render, staticRenderFns } from "./ProductGetPrice.vue?vue&type=template&id=d9c44d4e&scoped=true&"
import script from "./ProductGetPrice.vue?vue&type=script&lang=js&"
export * from "./ProductGetPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c44d4e",
  null
  
)

export default component.exports